import * as React from 'react';

import { Container, Typography} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import CategoryMenu from "../components/CategoryMenu.jsx";
import * as ApiCall from '../ApiCall.jsx';

// loads the menu which is a list of category dop downs which each contain their dishes
// clicking a dish takes you to its page
function Menu() {

  const [state, setState] = React.useState('loading');
  const [categories, setCategories] = React.useState([]);

  // given a category, adds it to the end of the list
  function addCategory(category) {
    let copy = categories;
    copy.push(category);
    setCategories(copy);
  }

  //set state to loading while apiCalling
  React.useEffect(() => {

    ApiCall.get('/menu')
      .then((menu) => {
        for (let i = 0; i < menu.length; i++) {
          addCategory(menu[i]);    
        }
        setState("success");
      })
      .catch((msg) => { alert("Failed to get menu: " + msg) })
  }, []);

  if (state === "loading") {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  else  if (state === "success") { 
    return (
      <Container sx={{display: 'flex', justifyContent: 'center',  flexDirection: 'column', flexWrap: 'wrap'}}>
        <Typography variant="h2" align='center' sx={{m: 5}}>Menu</Typography>
        {
          categories.map((category) => (
            <CategoryMenu key={category.id} categoryInfo={category} ></CategoryMenu>
          ))
        }
      </Container>

    )
  }
}
export default Menu;
